import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const Icon3dPackage2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-Icon3dPackage2"><Path d="M12.0018 1.75L20.8785 6.875V17.125L12.0018 22.25L3.125 17.125V6.875L12.0018 1.75Z" stroke="currentColor"/><Path d="M20.8785 6.875L12.0018 12M12.0018 22.25V12M3.125 6.875L12.0018 12" stroke="currentColor"/><Path d="M16.6895 9.00471L16.9395 9.14827V14.5711L15.9395 15.1483V9.72542L7.3125 4.74495L8.32785 4.17742L16.6895 9.00471Z" fill="currentColor"/></CentralIconBase>;
});

export default Icon3dPackage2;
